import { Grid, Card, IconButton, ButtonBase } from '@mui/material';
import React, { useState } from 'react';
import { MessageIcon } from 'tt-ui-lib/icons';
import { AppAvatar } from 'components/Avatar';
import { useNavigate } from 'react-router-dom';
import styles from '../../../CommunityPage.module.scss';
import { getAvatarPathBySize } from '../../../../../utils/appUtils';

const CompanyGridListItem = ({ company }) => {
  const [openOptions, setOpenOptions] = useState(false);
  const router = useNavigate();
  const endpointMarket = process.env.REACT_APP_MARKET;

  return (
    <Grid item key={company.id} xs={6} sm={4} md={3} xl={3}>
      <Card className={styles.card}>
        <div className={styles.cardImageBlock}>
          <div
            className={styles.cardImage}
            onClick={() => window.open(`${endpointMarket}/dashboard/company/${company?.id}`)}
          >
            <AppAvatar
              userName={company.company_name}
              src={getAvatarPathBySize(company.logos, 'smallPath')}
              nav={0}
              size="lg"
            />
          </div>

          <div
            className={styles.gridCardName}
            onClick={() => window.open(`${endpointMarket}/dashboard/company/${company?.id}`)}
          >
            {company.company_name}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
        <div className={styles.cardActions}>
          {/* <IconButton> */}
          {/*  <FavoriteBorderIcon sx={{ color: '#18397A' }} /> */}
          {/* </IconButton> */}
          <IconButton onClick={() => router(`/messaging?company=${company.id}`)}>
            <MessageIcon className={styles.itemIcon} />
          </IconButton>
          {/* <IconButton onClick={() => setOpenOptions(company.id)}> */}
          {/*  <MoreVertIcon sx={{ color: '#18397A' }} /> */}
          {/* </IconButton> */}
          {openOptions && (
            <div
              style={{ marginTop: 50, marginRight: -36 }}
              className={styles.optionsWindow}
              onMouseLeave={() => setOpenOptions(false)}
            >
              <ButtonBase className={styles.options} onClick={() => setOpenOptions(false)}>
                Follow
              </ButtonBase>
              <ButtonBase
                className={styles.options}
                onClick={() => setOpenOptions(false)}
                sx={{ marginTop: '16px' }}
              >
                Connect
              </ButtonBase>
            </div>
          )}
        </div>
      </Card>
    </Grid>
  );
};

export default CompanyGridListItem;
